module.exports = __webpack_public_path__ + "img/borrar.59715eda.svg";